/**
Coded by www.techhighway.ca

*/

import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import PropTypes from "prop-types";
import { forwardRef } from "react";

// Custom styles for MDButton
import MDCheckboxRoot from "components/MDCheckbox/MDCheckboxRoot";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

const MDCheckbox = forwardRef(
  ({ label, labelPlacement, name, checked, onChange, disabled, ...rest }, ref) => {
    const [controller] = useMaterialUIController();

    return (
      <Box>
        <FormControlLabel
          label={label}
          labelPlacement={labelPlacement}
          control={
            <MDCheckboxRoot
              checked={checked}
              onChange={onChange}
              disabled={disabled}
              name={name || ""}
              {...rest}
              ownerState={{ disabled }}
            />
          }
        />
      </Box>
    );
  }
);

// Setting default values for the props of MDButton
MDCheckbox.defaultProps = {
  disabled: false,
  size: "small",
};

// Typechecking props for the MDCheckbox
MDCheckbox.propTypes = {
  labelPlacement: PropTypes.oneOf(["top", "bottom", "start", "end"]),
};

export default MDCheckbox;
